import { render, staticRenderFns } from "./DialogAddress.vue?vue&type=template&id=6c6b109c&scoped=true"
import script from "./DialogAddress.vue?vue&type=script&lang=js"
export * from "./DialogAddress.vue?vue&type=script&lang=js"
import style0 from "./DialogAddress.vue?vue&type=style&index=0&id=6c6b109c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b109c",
  null
  
)

export default component.exports